import { render, staticRenderFns } from "./WorkflowInvocationInputOutputTabs.vue?vue&type=template&id=ea5ea45a"
import script from "./WorkflowInvocationInputOutputTabs.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkflowInvocationInputOutputTabs.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports